import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export class TwoColumnContent extends React.PureComponent {
  static propTypes = {
    leftColumn: PropTypes.any,
    rightColumn: PropTypes.any,
    isPetplace: PropTypes.bool,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    isPetplace: false,
  }

  render() {
    const {
      leftColumn,
      rightColumn,
      isPetplace,
      id,
      className,
      style,
      refProp
    } = this.props

    return (
      <div
        id={id}
        className={cn('ui-two-column-content-content', { 'ui-petplace-two-column-content-content': isPetplace }, className)}
        style={style}
        ref={refProp}
      >
        <div className={cn('ui-two-column-content__column', { 'ui-petplace-two-column-content__column': isPetplace })}>{leftColumn}</div>
        <div className={cn('ui-two-column-content__column', { 'ui-petplace-two-column-content__column': isPetplace })}>{rightColumn}</div>
      </div>
    )
  }
}
